import { createContext, useContext, useReducer, useEffect } from 'react'
import themeReducer from './themeReducer'

const ThemeContext = createContext()

const initialThemeState = JSON.parse(localStorage.getItem('themeSettings')) || {
  primary: 'color-1',
  background: 'bg-1',
}

export const ThemeProvider = ({ children }) => {
  const [themeState, dispatchTheme] = useReducer(
    themeReducer,
    initialThemeState,
  )

  const themeHandler = (buttonClassName) => {
    dispatchTheme({ type: buttonClassName })
  }

  // same theme setting in local storage
  useEffect(() => {
    localStorage.setItem('themeSettings', JSON.stringify(themeState))
    // eslint-disable-next-line
  }, [themeState.primary, themeState.background])

  return (
    <ThemeContext.Provider value={{ themeState, themeHandler }}>
      {children}
    </ThemeContext.Provider>
  )
}

// Custom hook to use our theme context wherever we want in our project
export const useThemeContext = () => {
  return useContext(ThemeContext)
}
